// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"f221e15d","81":"b723dc30","205":"6784f317","213":"d00aafde","435":"d00aafde","541":"a8570301","950":"64df6a18"}[chunkId] + ".css";
};